module.exports = __webpack_public_path__ + "static/img/detail-collegeD.b35b3f98.png";